const scene = "profile";

export const UPDATE_PROFILE = `${scene}UPDATE_PROFILE`;
export const UPDATE_PROFILE_DETAILS = `${scene}UPDATE_PROFILE_DETAILS`;